var CP = CP || {};
CP.SEARCH = CP.SEARCH || {};

(function ($, cp) {

	function initAutocomplete($this) {
		//Autocomplete
		var element = $this.find('.autocomplete-wrap');
		var selectorId = $this.data('id');
		var id = selectorId;
		var dataPlaceholder = $this.data("placeholder");

		function customSuggest(query, syncResults) {
			$.ajax({
				url: "/_api/Search/TypeAheadSearch",
				type: "post",
				data: {
					SearchTerm: query,
					Id: CP.BOE.ContentPageSearchDataSourceID
				}
			}).done(function (results) {
				var valuesFiltered = results.suggestions.filter(function (result) {
					return result.value.toLowerCase().indexOf(query.toLowerCase()) !== -1;
				});
				syncResults(valuesFiltered);
			});
		}
		function inputValueTemplate(result) {
			return result && result.value;
		}

		function suggestionTemplate(result) {
			return result && result.value;
		}

		function onConfirm(result) {
			window.location.href = result.data;
		}

		accessibleAutocomplete({
			element: element[0],
			id: id,
			source: customSuggest,
			//autoselect: true,
			confirmOnBlur: false,
			displayMenu: 'overlay',
			minLength: 3,
			placeholder: dataPlaceholder,
			showNoOptionsFound: false,
			onConfirm: onConfirm,
			templates: {
				inputValue: inputValueTemplate,
				suggestion: suggestionTemplate
			}
		});

	};

	//General Search
	if ($('.general-search').length > 0) {
		initAutocomplete($('.general-search'));
	}


	//Filters Search
	if ($('#SearchResultsPage').length > 0) {

		$('.filter-search').each(function () {
			var $this = $(this);
			if ($this.data('type') != 'searchPage') {
				return;
			}

			initAutocomplete($this);

			var input = $this.find('input[type="text"].autocomplete__input');
			var submit = $this.find('input[type="submit"]');
			var dataEmpty = $this.data("empty");
			var clear = $this.find('.search-widget-clear');
			var error = $this.find('.search-widget-error');
			var errorText = "Nothing searched for. Please enter a search term.";
			input.attr("data-error", errorText).attr('aria-labelledby', 'content-search-error').attr('aria-describedby', 'content-search-error');

			input.on('keyup', function (e) {
				if (e.which == 13) {
					if (!$(this).val()) {
						input.attr("placeholder", dataEmpty).attr('aria-invalid', 'true').addClass('error');
						
						if (!$(error).html().trim()) {
							error.append('<p>' + errorText + '</p>');
						}
						return;
					}
					$(this).data('value', $(this).val());
					CP.SEARCH.initFilters();
				}
				if (e.which != 13 && $(this).val()) {
					$(this).attr("placeholder", dataPlaceholder).attr('aria-invalid', 'false').removeClass('error');
					error.find('p').remove();
					clear.css("display", "block");
				}
				if (!$(this).val()) {
					clear.css("display", "none");
				}
			});

			// Clean search box
			clear.on('click', function (e) {
				e.preventDefault();

				if (!input.data('value')) {
					input.val("");
					clear.css("display", "none");
				} else {
					input.val("");
					input.data('value', '');
					clear.css("display", "none");
					CP.SEARCH.initFilters();
				}
				input.attr('tabindex', '-1');
				setTimeout(function () {
					input.trigger('focus');
				}, 100);
				return false;
			});

			submit.on('click', function () {
				if (!input.val()) {
					input.attr("placeholder", dataEmpty).attr('aria-invalid', 'true').addClass('error').trigger('focus');
					if (!$(error).html().trim()) {
						error.append('<p>' + errorText + '</p>');
					}
					return;
				}
				input.data('value', input.val());
				CP.SEARCH.initFilters();
			});
		});

		$('.js-calendar').on('keydown', function (e) {
			if (e.key === 'Enter') {
				CP.SEARCH.initFilters();
			}

		});
	}


	var search = $(".general-search");
	var input = search.find('input[type="text"].autocomplete__input');
	var clear = search.find('.search-widget-clear');
	var dataEmpty = search.data("empty");
	var dataPlaceholder = search.data("placeholder");
	var error = search.find('.search-widget-error');
	var errorText = "Nothing searched for. Please enter a search term.";
	input.attr("data-error", errorText).attr('aria-labelledby', 'search-error').attr('aria-describedby', 'search-error');

	//keypress for general search in homepage and header
	input.on('keyup', function (e) {
		if (e.which == 13) {
			if ($(this).val()) {
				$(this).closest('form').trigger('submit');
			}
		}
		if (e.which != 13 && $(this).attr("placeholder") == dataEmpty) {
			$(this).attr("placeholder", dataPlaceholder).attr('aria-invalid', 'false').removeClass('error');
			error.find('p').remove();
			search.removeClass('error');
			clear.css("display", "block");
		}
		if (e.which != 13 && !$(this).val()) {
			clear.css("display", "none");
		}
	});

	// Clean search box
	clear.on('click', function (e) {
		e.preventDefault();
		input.val("");
		clear.css("display", "none");
		input.attr('tabindex', '-1');
		setTimeout(function () {
			input.trigger('focus');
		}, 100);
		return false;
	});

	CP.SEARCH.Submit = function (targetPage, queryParam, extraParams) {

		if (input.val().trim() !== "") {
			if (extraParams !== "")
				document.location = targetPage + "?" + queryParam + "=" + input.val() + "&" + extraParams;
			else
				document.location = targetPage + "?" + queryParam + "=" + input.val();
			return false;
		}

		input.attr("placeholder", dataEmpty).attr('aria-invalid', 'true').addClass('error').trigger('focus');
		if (!$(error).html().trim()) {
			error.append('<p>' + errorText + '</p>');
		}
		
		search.addClass('error');
		return false;
	};

	CP.SEARCH.initSortedBy = function (elem) {
		var $this = $(elem);
		$this.data('value', $this.val());
		CP.SEARCH.initFilters();
	};

	CP.SEARCH.initPagination = function (elem) {
		var $this = $(elem);
		if ($this.hasClass('pagination-disabled')) {
			return;
		}
		var pagerDataElement = $this.closest('[data-page]');
		var currentPage = pagerDataElement.data('page');
		var pageCount = pagerDataElement.data('pagecount');

		if ($this.hasClass('list-pagination__link--page')) {
			currentPage = parseInt($this.data('page-link'));
			pagerDataElement.data('page', currentPage);
		}

		if ($this.hasClass('pagination-next') || $this.hasClass('list-pagination__link--next')) {
			if (pageCount > currentPage) {
				currentPage = currentPage + 1;
				pagerDataElement.data('page', currentPage);
			}
		}
		if ($this.hasClass('pagination-prev') || $this.hasClass('list-pagination__link--prev')) {
			if (currentPage > 1) {
				currentPage = currentPage - 1;
				pagerDataElement.data('page', currentPage);
			}
		}
		pagerDataElement.data('pagination', 'true');
		CP.SEARCH.initFilters();
	};

	CP.SEARCH.initClearFilters = function (elem) {
		var $this = $(elem);
		if ($this.hasClass('clear-type')) {
			$this.data('clear', 'type');
		}
		if ($this.hasClass('clear-taxonomy')) {
			$this.data('clear', 'taxonomy');
		}
		if ($this.hasClass('clear-dates')) {
			$this.data('clear', 'dates');
		}
		CP.SEARCH.initFilters();
	};

	CP.SEARCH.initGetFilters = function () {
		var query = '';
		var queryType = '';
		var queryTypeOptions = '';
		var queryTaxonomy = '';
		var page = '1';
		var sortBy = '1';
		var dateFrom;
		var dateTo;

		//Search
		$('.filter-search').each(function () {
			var $this = $(this);
			if (!$this.data('type') == 'searchPage') {
				return;
			}
			var searchCtrl = $this.find('input[type="text"].autocomplete__input');
			var inputValue = searchCtrl.data('value') || searchCtrl.val();

			if (inputValue)
				query = inputValue;
		});

		//Type
		var typeValues = $('.sidebar-filters.type-filters').find('input[type="checkbox"]').toArray();
		//queryTypeOptions = typeValues.map(function(obj) { return obj.value; });
		queryTypeOptions = CP.BOE.ContentPageTypes ? CP.BOE.ContentPageTypes : queryTypeOptions;
		typeValues = typeValues.filter(function (obj) { return obj.checked; });
		queryType = typeValues.map(function (obj) { return obj.value; });

		//Taxonomies
		var taxonomyValues = $('.sidebar-filters.taxonomy-filters').find('input[type="checkbox"]').toArray();
		var taxonomyValuesAvailable = CP.BOE.ContentPageTaxonomies ? CP.BOE.ContentPageTaxonomies : [];
		taxonomyValues = taxonomyValues.filter(function (obj) { return obj.checked; });
		queryTaxonomy = taxonomyValues.map(function (obj) { return obj.value; });

		//Sort By
		sortBy = $('.sort-by select').data('value');
		if (isUndefined(sortBy)) {
			sortBy = !isUndefined(CP.BOE.SortByParameter) ? CP.BOE.SortByParameter : '1';
		}

		//Pagination
		if ($('.container-list-pagination').data('pagination') == 'true') {
			var offset = ($(window).width() >= '1024') ? '90' : '20';
			page = $('.container-list-pagination').data('page');
			$("html, body").animate({ scrollTop: $("#SearchResults").offset().top - offset }, 1000);
		}
		$('.container-list-pagination').data('pagination', 'false');
		
		//Dates
		if ($('.date-field #cpageDateMin').length > 0) {
			var fromVal = $('.date-field #cpageDateMin').datepicker("getDate");
			if (fromVal) {
				dateFrom = fromVal.parseToISOString();
			}
		}
		if ($('.date-field #cpageDateMax').length > 0) {
			var toVal = $('.date-field #cpageDateMax').datepicker("getDate");
			if (toVal) {
				toVal.setDate(toVal.getDate() + 1);
				dateTo = toVal.parseToISOString();
			}
		}

		//Clear buttons
		if ($('.clear-type').data('clear')) {
			if (typeValues.length != 0) {
				//clear type
				queryType = [];
				//Uncheck inputs
				$.each(typeValues,
					function (index, value) {
						$(value).prop('checked', false);
					});
			}
			//remove data-type
			$('.clear-type').data('clear', '');
		}
		if ($('.clear-taxonomy').data('clear')) {
			if (taxonomyValues.length != 0) {
				//clear taxonomy
				queryTaxonomy = [];
				//Uncheck inputs
				$.each(taxonomyValues,
					function (index, value) {
						$(value).prop('checked', false);
					});
			}
			//remove data-type
			$('.clear-taxonomy').data('clear', '');
		}
		if ($('.clear-dates').data('clear')) {
			if (fromVal || toVal) {
				//clear dates
				dateFrom = undefined;
				dateTo = undefined;
				//Uncheck inputs
				$('.date-field #cpageDateMin').datepicker("setDate", '');
				$('.date-field #cpageDateMax').datepicker("setDate", '');
			}
			//remove data-type
			$('.clear-dates').data('clear', '');
		}

		var obj = {
			SearchTerm: query,
			Id: CP.BOE.ContentPageSearchDataSourceID,
			PageSize: CP.BOE.ContentPageSize,
			ReleaseTypes: queryType,
			ReleaseTypesAvailable: queryTypeOptions,
			Taxonomies: queryTaxonomy,
			TaxonomiesAvailable: taxonomyValuesAvailable,
			Page: page,
			ShowResultImage: CP.BOE.ShowResultImage, 
			OrderBy: sortBy,
			DateFrom: dateFrom,
			DateTo: dateTo
		};

		return obj;
	};

	CP.SEARCH.initFilters = function (reload) {

		var obj = CP.SEARCH.initGetFilters();

		initAjaxCall(obj, reload);
	};

	function initAjaxCall(obj, reload) {

		$("#SearchResults").css('display', 'none');
		$('.loading').css('display', 'block');
		$('.loading').html('<img src="/assets/img/loader.svg" role="progressbar" aria-busy="true" alt="" /><p class="loading-text">Content loading</p>');

		$.ajax({
			url: "/_api/Search/RefreshContentPageSearchList",
			type: "post",
			data: obj
		})
			.done(function (result) {
				$("#SearchResults").hide().html(result.Results).fadeIn(600, function () {
					$('.loading').empty();
					$('.loading').css('display', 'none');
				});
				$('.sidebar-filters.taxonomy-filters').hide().html(result.Refiners).fadeIn(600);

				$('.search-count').html(result.NumResultsTxt);
				$('#searchResultCountAnnounce').html('');
				setTimeout(function () {
					$('#searchResultCountAnnounce').html(result.NumResultsTxt);
				}, 500);

				IEimages();
			})
			.fail(function (e) {
				//console.log("error", e)
			});
		if (!reload) {
			history.pushState(obj, null, null);
		}
	};

	if ($('#SearchResultsPage').length > 0) {

		if (!$("body").hasClass("pagemode-edit")) {
			window.addEventListener('popstate', function (e) {
				var obj = e.state;
				if (obj) {
					initAjaxCall(obj, true);
					initRefreshTypes(obj.ReleaseTypes);
					initRefreshTaxonomies(obj.Taxonomies);
					initRefreshSearchbox(obj.SearchTerm);
					initRefreshOrderBy(obj.OrderBy);
					initRefreshDate(obj.DateFrom, obj.DateTo);
				} else {
					location.href = location.href;
				}
			});
		}
		if (PerformanceNavigationTiming.type === "reload" != 1 && history.state != null && history.state.Id && !$("body").hasClass("pagemode-edit")) {
			initRefreshTypes(history.state.ReleaseTypes);
			//initRefreshTaxonomies(history.state.Taxonomies);
			initRefreshSearchbox(history.state.SearchTerm);
			initRefreshOrderBy(history.state.OrderBy);
			initRefreshDate(history.state.DateFrom, history.state.DateTo);

			var obj = CP.SEARCH.initGetFilters();
			obj.Taxonomies = history.state.Taxonomies;
			initAjaxCall(obj);

		} else {
			//console.info("Initialise from page");
			//Delay necessary due to race conditions with browser restoring page state
			//when back button has been pressed.
			var delay = 300;
			setTimeout(function () {
				CP.SEARCH.initFilters(true);
			}, delay);
			//console.info("Delay: " + delay);	
		}
	};

	function initRefreshTypes(checked) {

		var typeCheckboxes = $('.sidebar-filters.type-filters').find('input[type="checkbox"]').toArray();
		var typeCheckboxesValues = typeCheckboxes.map(function (obj) { return obj.value; });

		for (var i = 0; i < typeCheckboxesValues.length; i++) {
			if (checked.indexOf(typeCheckboxesValues[i]) !== -1) {
				$(typeCheckboxes[i]).prop('checked', true);
			} else {
				$(typeCheckboxes[i]).prop('checked', false);
			}
		}
	};

	function initRefreshTaxonomies(checked) {

		var typeCheckboxes = $('.sidebar-filters.taxonomy-filters').find('input[type="checkbox"]').toArray();
		var typeCheckboxesValues = typeCheckboxes.map(function (obj) { return obj.value; });

		for (var i = 0; i < typeCheckboxesValues.length; i++) {
			if (checked.indexOf(typeCheckboxesValues[i]) !== -1) {
				$(typeCheckboxes[i]).prop('checked', true);
			} else {
				$(typeCheckboxes[i]).prop('checked', false);
			}
		}
	};

	function initRefreshSearchbox(SearchTerm) {
		$('.filter-search input[type="search"]').val(SearchTerm);
	};

	function initRefreshOrderBy(OrderBy) {
		$('.sort-by select').val(OrderBy);
	};

	function initRefreshDate(DateFrom, DateTo) {
		if (DateFrom) {
			DateFrom = new Date(DateFrom);
		} else {
			DateFrom = undefined;
		}
		if (DateTo) {
			DateTo = new Date(DateTo);
		} else {
			DateTo = undefined;
		}
		$('.date-field #cpageDateMin').datepicker("setDate", DateFrom);
		$('.date-field #cpageDateMax').datepicker("setDate", DateTo);
	};

	function IEimages() {
		if (!Modernizr.objectfit) {
			$('.releases-items .release').each(function () {
				var $imageContainer = $(this).find('.release-img'),
					imgUrl = $imageContainer.find('img').prop('src');
				if (imgUrl) {
					$imageContainer
						.css('backgroundImage', 'url(' + imgUrl + ')')
						.addClass('object-fit');
				}
			});
		}
	};

	function isUndefined(value) {
		// Obtain `undefined` value that's guaranteed to not have been re-assigned
		var undefined = void (0);
		return value === undefined;
	};

})(jQuery, CP.SEARCH);